import React, { useState, useEffect } from "react";
import logo from "../assets/media/livensa/Studios-livensaliving.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../base/context/authcontext";
import Cookies from "universal-cookie";

const LoginPage = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // 👈 nuevo estado
  const [isLoading, setIsLoading] = useState(false);
  const [showAlert, setIshowAlert] = useState(false);
  const [sessionTokenExists, setSessionTokenExists] = useState(false);
  const cookies = new Cookies();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const { success, redirect } = await login(email, password);

    if (success) {
      setIshowAlert(false);
      if (redirect) {
        navigate(redirect);
      } else {
        navigate("/planification");
        setSessionTokenExists(true);
      }
    } else {
      setIshowAlert(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const sessionToken = cookies.get("session_token");
    if (sessionToken) {
      navigate("/planification");
    }
  }, [sessionTokenExists, navigate, cookies]);

  return (
    <>
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-lg-row-fluid w-lg-50 bg-azul-color-azul-livensa">
          <div className="d-flex flex-column flex-center p-6 p-lg-10 w-100">
            <a
              href="#"
              className="mb-0 mb-lg-20"
              onClick={(e) => e.preventDefault()}
            >
              <img alt="Logo" src={logo} className="h-40px h-lg-50px" />
            </a>
            <img
              className="d-none d-lg-block mx-auto w-300px w-lg-75 w-xl-500px mb-10 mb-lg-20"
              src="/media/misc/auth-screens.png"
              alt=""
            />
            <h1 className="d-none d-lg-block text-white fs-2qx fw-bold text-center mb-7">
              Rápido, eficiente y productivo
            </h1>
            <div className="d-none d-lg-block text-white fs-base text-center">
              Gestiona de manera{" "}
              <a className="opacity-75-hover text-warning fw-semibold me-1">
                inteligente
              </a>
              las habitaciones
              <br /> de tus alojamientos con una interfaz
              <a className="opacity-75-hover text-warning fw-semibold me-1">
                {" "}
                rápida
              </a>
              que mejora en gran medida tu <br />
              <a className="opacity-75-hover text-warning fw-semibold me-1">
                productividad
              </a>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10">
          <div className="d-flex flex-center flex-column flex-lg-row-fluid">
            <div className="w-lg-500px p-10">
              <form className="form w-100" onSubmit={handleLogin}>
                <div className="text-center mb-11">
                  <h1 className="text-gray-900 fw-bolder mb-3">
                    Iniciar sesión
                  </h1>
                </div>

                <div className="row g-3 mb-9">
                  <div className="col-md-12">
                    <button
                      type="button"
                      className="btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100"
                    >
                      <img
                        alt="Logo"
                        src="/media/svg/brand-logos/microsoft-5.svg"
                        className="h-15px me-3"
                      />
                      Inicia sesión con 365
                    </button>
                  </div>
                </div>

                <div className="separator separator-content my-14">
                  <span className="w-125px text-gray-500 fw-semibold fs-7">
                    O con email y contraseña
                  </span>
                </div>

                {showAlert && (
                  <div className="alert alert-danger d-flex align-items-center p-5">
                    <i className="fa-solid fa-triangle-exclamation fs-1 text-danger me-4"></i>
                    <div className="d-flex flex-column">
                      <span className="mb-1 text-danger">
                        Usuario o contraseña incorrecta
                      </span>
                    </div>
                  </div>
                )}

                <div className="fv-row mb-8">
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    className="form-control bg-transparent"
                    required
                  />
                </div>

                {/* Campo contraseña con ojo */}
                <div className="fv-row mb-3 position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Contraseña"
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    className="form-control bg-transparent pe-12"
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-sm btn-icon position-absolute top-50 translate-middle-y end-0 me-3"
                    aria-label={
                      showPassword ? "Ocultar contraseña" : "Mostrar contraseña"
                    }
                    onClick={() => setShowPassword((v) => !v)}
                    tabIndex={-1}
                    style={{ outline: "none" }}
                  >
                    <i
                      className={`fa-solid ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      } fs-3`}
                    ></i>
                  </button>
                </div>

                <div className="d-grid mb-10">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    data-kt-indicator={isLoading ? "on" : "off"}
                    disabled={isLoading}
                  >
                    <span className="indicator-label">Iniciar sesión</span>
                    <span className="indicator-progress">
                      Autenticando...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
